import service from '../../service'
const state = {
  shopNum: 0
};

const mutations = {
  UPD_SHOPCAR_NUM: (state, num) => {
    state.shopNum = num;
  }  
};

const actions = {
  async updShopCarNums({commit}){
    try{
      let res = await service.getShopCarNum();
      let shopNum=0;
      if(res && res.status==200){
        if(res.result>99){
          shopNum="99+";
        }else{
          shopNum=res.result;
        }
      }
      commit("UPD_SHOPCAR_NUM",shopNum)
    }catch(e){
      commit("UPD_SHOPCAR_NUM",0)
    }
    
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
